module.exports = __webpack_public_path__ + "img/ic_home.5641de84.svg";